export class PrevDailyReportData {
    Summary;
    Detail;

    constructor(summary, detail) {  
        this.Summary = summary;
        this.Detail = detail;
    }
}